module.exports = "<svg viewBox=\"40 0 6 7\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><polygon id=\"Triangle\" stroke=\"none\" fill=\"#000000\" fill-rule=\"evenodd\" points=\"40 7 40 0 46 3.5\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/fill/triangle.svg
// module id = 614
// module chunks = 0 1